import React, { useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';

const AddIoAllocation = ({ open, onCancel, onSubmit, initialData = null, setEditIoAllocation }) => {
        const [form] = Form.useForm();
        const isEditMode = initialData && Object.keys(initialData).length > 0;

        const handleOk = async () => {
                try {
                        const values = await form.validateFields();

                        const result = await onSubmit(values);

                        if (result?.status === 'success') {
                                form.resetFields();
                                setEditIoAllocation({});
                        }
                } catch (err) {
                        console.log('Validation or submission error:', err);
                }
        };

        useEffect(() => {
                if (initialData && isEditMode) {
                        form.setFieldsValue(initialData);
                } else {
                        form.resetFields();
                }
        }, [initialData, open]);

        return (
                <Modal
                        title={isEditMode ? 'Edit IO Allocation' : 'Add IO Allocation'}
                        open={open}
                        onCancel={() => {
                                form.resetFields();
                                onCancel();
                        }}
                        onOk={handleOk}
                        footer={[
                                <Button
                                        key="cancel"
                                        onClick={onCancel}>
                                        Cancel
                                </Button>,
                                <Button
                                        key="submit"
                                        type="primary"
                                        onClick={handleOk}>
                                        {isEditMode ? 'Update IO Allocation' : 'Add IO Allocation'}
                                </Button>,
                        ]}
                        width={600}>
                        <Form
                                form={form}
                                layout="vertical"
                                className="custom-form-scroll"
                                style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                {[
                                        { label: 'IO Number', name: 'IO_NO', disabled: isEditMode },
                                        { label: 'Revision Number', name: 'REV_NO', disabled: isEditMode },
                                        { label: 'Manufacturing Unit', name: 'MNF_UNIT', disabled: isEditMode },
                                        { label: 'BS Unit', name: 'BS_UNIT', disabled: isEditMode },
                                        { label: 'Head Type', name: 'HEAD_TYPE', disabled: isEditMode },
                                        { label: 'Allocated Value', name: 'ALLOCATED_VALUE' },
                                ].map(({ label, name, disabled }) => (
                                        <Form.Item
                                                key={name}
                                                name={name}
                                                label={
                                                        <div className="flex justify-between items-center gap-2">
                                                                <label className="text-left pr-4">
                                                                        {label}
                                                                        <span className="text-red-500">*</span>
                                                                </label>
                                                        </div>
                                                }
                                                labelCol={{ span: 7 }} // Roughly 40% in 24-grid system
                                                wrapperCol={{ span: 14 }} // Remaining 60%
                                                layout="horizontal"
                                                required={false} // ✅ Suppresses automatic red asterisk
                                                rules={[
                                                        {
                                                                required: true,
                                                                message: `${label} is required`,
                                                        },
                                                ]}>
                                                <Input
                                                        className="w-full"
                                                        disabled={disabled}
                                                />
                                        </Form.Item>
                                ))}
                        </Form>
                </Modal>
        );
};

export default AddIoAllocation;
